var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation"},[_c('nav',{staticClass:"nav-year"},[_c('carousel',{attrs:{"per-page":_vm.numSlides,"navigationEnabled":true,"paginationEnabled":false,"navigate-to":_vm.someLocalProperty,"mouse-drag":true}},_vm._l((_vm.links),function(link){return _c('slide',{key:link},[_c('router-link',{class:{ disabled: _vm.checkCountry(link)},attrs:{"event":_vm.isDisabled(link),"to":{
        'name': _vm.$route.name,
        'params': { year: link }
    }}},[_vm._v("\n      "+_vm._s(link)+"\n    ")])],1)}),1)],1),_c('nav',{staticClass:"nav-category"},[_c('router-link',{attrs:{"to":{
      'name': 'stats',
      'params': { view: 'portrait', year: _vm.$route.params.year }}}},[_vm._v("Länderportrait\n    ")]),_c('router-link',{attrs:{"to":{
      'name': 'stats',
      'params': { view: 'comparison', year: '2024' }}}},[_vm._v("Rankingverlauf vergleichen\n    ")]),_c('router-link',{attrs:{"to":{
      'name': 'stats',
      'params': { view: 'ranking', year: _vm.$route.params.year }}}},[_vm._v("Länderranking\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }